import { Component, signal } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { AccountLockedComponent } from '../../../shared/components/account-locked/account-locked.component';

@Component({
  selector: 'app-login',
  standalone: false,
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent {
  form: FormGroup;
  showPassword = signal(false);
  isLoading = signal(false);
  errorMessage = signal('');
  submitted = signal(false);

  // locked state
  isLocked = signal(false);
  lockedMinutes = signal(5);

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private authService: AuthService,
  ) {
    this.form = this.fb.group({
      email: ['', [Validators.required]],
      password: ['', [Validators.required]],
      rememberMe: [false],
    });
  }

  get email() { return this.form.get('email')!; }
  get password() { return this.form.get('password')!; }
  get isFormValid() { return this.form.valid; }

  togglePassword() {
    this.showPassword.update(v => !v);
  }

  async onSubmit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.submitted.set(true);
    this.isLoading.set(true);
    this.errorMessage.set('');

    try {
      // Replace with your actual auth service call
      // await this.authService.login(this.form.value);
      // await new Promise(r => setTimeout(r, 1200)); // simulate API call
      await this.authService.login({
        email: this.form.value.email,
        password: this.form.value.password,
      }).subscribe({
        error: (err) => {
          this.isLoading.set(false);
          const message: string = err.error?.message ?? 'Invalid credentials.';


          // 403 = account locked or deactivated
          if (err.status === 403 && message.toLowerCase().includes('locked')) {
            const minutes = AccountLockedComponent.parseMinutesFromError(message);
            this.lockedMinutes.set(minutes);
            this.isLocked.set(true);
            return;
          }
          this.errorMessage.set(message);

        },
        complete: () => this.isLoading.set(false),
      });
      // this.router.navigate(['/dashboard']);
    } catch (err: any) {
      this.errorMessage.set(err?.message ?? 'Invalid credentials. Please try again.');
    } finally {
      this.isLoading.set(false);
    }
  }

  // Countdown reached 0 — swap the lock screen back to the login form
  onLockExpired() {
    this.isLocked.set(false);
    this.errorMessage.set('');
    this.submitted.set(false);
    this.form.patchValue({ password: '' });
  }

  onForgotPassword() {
    this.router.navigate(['/forgot-password']);
  }


}
